import { initScrollClasses, initModal, initCtaModal, initAfterInteract, userWayRorder } from "./functions/core";
import { initDatalayer, readCookiePermissions, readCookie } from "./functions/cookies/core";
import { validateFormBootstrap, validateFormModalBootstrap } from "./functions/forms/validation";

import { initGsap } from "./functions/initializers/gsap";
import { initHomeBannerGsap } from "./functions/initializers/home-banner";
import { initJquery } from "./functions/initializers/jquery";
import { initSelect2 } from "./functions/initializers/select2";
import { initDatepicker } from "./functions/initializers/datepicker";
import { toggleCollapseOnParent } from "./functions/initializers/parent-collapse";
import { initTimepicker } from "./functions/initializers/timepicker";
import { initSwiper } from "./functions/initializers/swiper";
import { initMarquee } from "./functions/initializers/marquee";
import { initFileInput } from "./functions/initializers/file-input";
import { initCookiesBox } from "./functions/initializers/cookie-box";
import { initBootstrap, copyToClipboard } from "./functions/initializers/bootstrap";

// Add functions to the global window object to give access to backend devs
document.addEventListener("DOMContentLoaded", async () => {
	console.log("Developed by LOBA - https://www.loba.com/");

	//=== Core ===//

	initScrollClasses('.header')
	window.initModal = initModal;
	initCtaModal('#ctaModal')
	window.initCtaModal = initCtaModal;

	//=== Cookies ===//

	initDatalayer()
	readCookiePermissions('loba_')
	window.readCookie = readCookie;
	window.initCookiesBox = initCookiesBox;

	Promise.all([
		// Swiper
		initSwiper('.swiper-from-dataset'),
		// Custom Marquee
		initMarquee('.marquee'),
		// Allow collapse to toggle a classe on any parent element
		toggleCollapseOnParent(),
		// Reorder userway widget
		userWayRorder(),
		// Init website core gsap
		initGsap(),
		initHomeBannerGsap('.banner--home'),
		//=== Bootstrap ===//
		copyToClipboard('.clipboard-copy'),
		initBootstrap({
			'critical': ["initCollapse"] // Collapse is critical for the menu, everything else can be lazy loaded in most cases
		})
	]).then(() => {
		window.initDatepicker = initDatepicker
	})

	//=== Non-Critical Functions ===//

	Promise.all([
		initAfterInteract([
			// Datepicker
			()=>initDatepicker('.datepicker-input'),
			// Timepicker
			()=>initTimepicker('.timepicker-input'),
			// File Input
			()=>initFileInput(".custom-file input"),
		])
	]).then(() => {
		window.initTimepicker = initTimepicker
		window.initFileInput = initFileInput;
	})

	//=== Forms ===//

	validateFormBootstrap(".needs-validation")
	validateFormModalBootstrap(".modal-submit")


   // Accordion
     const accordionItems = document.querySelectorAll('[data-accordion-item]');
    
    accordionItems.forEach((item, index) => {
        const trigger = item.querySelector('[data-accordion-trigger]');
        const content = item.querySelector('[data-accordion-content]');
        const button = item.querySelector('.accordion-button');
        
        trigger.addEventListener('click', function() {
            // Close all other items
            accordionItems.forEach((otherItem, otherIndex) => {
                if (otherIndex !== index) {
                    otherItem.classList.remove('active');
                    const otherButton = otherItem.querySelector('.accordion-button');
                    if (otherButton) {
                        otherButton.setAttribute('aria-expanded', 'false');
                    }
                }
            });
            
            // Toggle current item
            const isActive = item.classList.contains('active');
            if (isActive) {
                item.classList.remove('active');
                button.setAttribute('aria-expanded', 'false');
            } else {
                item.classList.add('active');
                button.setAttribute('aria-expanded', 'true');
            }
        });
    });
	
});


initJquery().then(() => {
	function runWhenDOMReady(){
		// jQuery dependant code should be placed here

		//=== Select2 ===//
		initSelect2('.custom-select-option select')
		window.initSelect2 = initSelect2;
	}

	if (document.readyState === 'interactive' || document.readyState === 'complete') { runWhenDOMReady(); } else { document.addEventListener('DOMContentLoaded', runWhenDOMReady);}
})



let currentStep = 1;
let uploadedFiles = [];

function handleFileUpload(input) {
    const files = Array.from(input.files);
    const validFiles = [];
    
    files.forEach(file => {
        // Check if it's a PDF and under 2MB
        if (file.type === 'application/pdf' && file.size <= 2 * 1024 * 1024) {
            validFiles.push(file);
        } else {
            alert(`File "${file.name}" is either not a PDF or exceeds 2MB limit.`);
        }
    });
    
    if (validFiles.length > 0) {
        uploadedFiles = [...uploadedFiles, ...validFiles];
        showUploadedFiles();
    }
}

function showUploadedFiles() {
    const initialState = document.getElementById('upload-initial-state');
    const successState = document.getElementById('upload-success-state');
    const filesList = document.getElementById('uploaded-files-list');
    
    // Hide initial state and show success state
    initialState.classList.add('d-none');
    successState.classList.remove('d-none');
    
    // Clear previous files list
    filesList.innerHTML = '';
    
    // Add each uploaded file
    uploadedFiles.forEach((file, index) => {
        const fileItem = document.createElement('div');
        fileItem.className = 'bg-dark text-white px-3 py-2 d-flex align-items-center gap-2';
        fileItem.style.minWidth = '252px';
        
        fileItem.innerHTML = `
            <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path d="M20 6L9 17L4 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span class="text-truncate">${file.name}</span>
            <button type="button" class="btn-close btn-close-white ms-auto" onclick="removeFile(${index})" aria-label="Remove file"></button>
        `;
        
        filesList.appendChild(fileItem);
    });
}

function removeFile(index) {
    uploadedFiles.splice(index, 1);
    
    if (uploadedFiles.length === 0) {
        // Show initial state again if no files
        document.getElementById('upload-initial-state').classList.remove('d-none');
        document.getElementById('upload-success-state').classList.add('d-none');
    } else {
        // Update the files list
        showUploadedFiles();
    }
}

function validateAndNext(step) {
    const currentSection = document.querySelector(`#form-section-${step}`);
    const requiredFields = currentSection.querySelectorAll('input[required], textarea[required]');
    let isValid = true;
    let firstInvalidField = null;
    
    // Remove previous error styling
    document.querySelectorAll('.is-invalid').forEach(field => {
        field.classList.remove('is-invalid');
    });
    
    // Validate each required field in current section
    requiredFields.forEach(field => {
        if (!field.value.trim()) {
            isValid = false;
            field.classList.add('is-invalid');
            if (!firstInvalidField) {
                firstInvalidField = field;
            }
        }
    });
    
    // Special validation for Step 1 required fields
    if (step === 1) {
        // Validate organization type radio buttons (required but not marked as such)
        const organizationTypeRadios = currentSection.querySelectorAll('input[name="organisation_type"]');
        const isOrganizationTypeSelected = Array.from(organizationTypeRadios).some(radio => radio.checked);
        
        if (!isOrganizationTypeSelected) {
            isValid = false;
            // Add is-invalid class to all organization type radio buttons
            organizationTypeRadios.forEach(radio => {
                radio.classList.add('is-invalid');
            });
            if (!firstInvalidField) {
                firstInvalidField = organizationTypeRadios[0];
            }
        }
    }
    
    // Special validation for Step 2 required fields
    if (step === 2) {
        // Validate development stage radio buttons (required)
        const developmentStageRadios = currentSection.querySelectorAll('input[name="development_stage"]');
        const isDevelopmentStageSelected = Array.from(developmentStageRadios).some(radio => radio.checked);
        
        if (!isDevelopmentStageSelected) {
            isValid = false;
            // Add is-invalid class to all development stage radio buttons
            developmentStageRadios.forEach(radio => {
                radio.classList.add('is-invalid');
            });
            if (!firstInvalidField) {
                firstInvalidField = developmentStageRadios[0];
            }
        }
        
        // Validate regulatory attempts radio (required)
        const regulatoryAttempts = currentSection.querySelectorAll('input[name="regulatory_attempts"]');
        const isRegulatorySelected = Array.from(regulatoryAttempts).some(radio => radio.checked);
        
        if (!isRegulatorySelected) {
            isValid = false;
            // Add is-invalid class to all regulatory radio buttons
            regulatoryAttempts.forEach(radio => {
                radio.classList.add('is-invalid');
            });
        }
        
        // Validate quality management radio (required)
        const qualityManagement = currentSection.querySelectorAll('input[name="quality_management"]');
        const isQualitySelected = Array.from(qualityManagement).some(radio => radio.checked);
        
        if (!isQualitySelected) {
            isValid = false;
            // Add is-invalid class to all quality management radio buttons
            qualityManagement.forEach(radio => {
                radio.classList.add('is-invalid');
            });
        }
    }
    
    if (isValid) {
        // Move to next section immediately
        goToNextStep(step);
    } else {
        // Focus on first invalid field
        if (firstInvalidField) {
            firstInvalidField.focus();
            firstInvalidField.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }
}

function goToNextStep(currentStepNum) {
    // Hide current section
    document.querySelector(`#form-section-${currentStepNum}`).classList.add('d-none');
    
    // Show next section (only up to step 3)
    const nextStep = currentStepNum + 1;
    if (nextStep <= 3) {
        document.querySelector(`#form-section-${nextStep}`).classList.remove('d-none');
        currentStep = nextStep;
        
        // Scroll to top
        document.querySelector(`#form-section-${nextStep}`).scrollIntoView({ 
            behavior: 'smooth', 
            block: 'start' 
        });
    }
}

function goToPreviousStep(currentStepNum) {
    // Hide current section
    document.querySelector(`#form-section-${currentStepNum}`).classList.add('d-none');
    
    // Show previous section
    const prevStep = currentStepNum - 1;
    if (prevStep >= 1) {
        document.querySelector(`#form-section-${prevStep}`).classList.remove('d-none');
        currentStep = prevStep;
        
        // Scroll to top
        document.querySelector(`#form-section-${prevStep}`).scrollIntoView({ 
            behavior: 'smooth', 
            block: 'start' 
        });
    }
}

function submitForm(event) {
    // Validate Step 3 first
    const currentSection = document.querySelector('#form-section-3');
    const requiredFields = currentSection.querySelectorAll('input[required], textarea[required]');
    let isValid = true;
    let firstInvalidField = null;
    
    // Remove previous error styling
    document.querySelectorAll('.is-invalid').forEach(field => {
        field.classList.remove('is-invalid');
    });
    
    // Validate each required field in Step 3
    requiredFields.forEach(field => {
        if (!field.value.trim()) {
            isValid = false;
            field.classList.add('is-invalid');
            if (!firstInvalidField) {
                firstInvalidField = field;
            }
        }
    });
    
    if (isValid) {
        // Hide the form and show success message
        document.querySelector('form').classList.add('d-none');
        document.querySelector('#success-message').classList.remove('d-none');
        
        // Here you would normally submit the form data to the server
        console.log('Form data would be submitted here');
        
        // Scroll to top of success message
        document.querySelector('#success-message').scrollIntoView({ 
            behavior: 'smooth', 
            block: 'start' 
        });
    } else {
        // Focus on first invalid field
        if (firstInvalidField) {
            firstInvalidField.focus();
            firstInvalidField.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }
    
    // Prevent form submission
    if (event) {
        event.preventDefault();
    }
    return false;
}


// Make functions globally accessible for onclick handlers
window.handleFileUpload = handleFileUpload;
window.showUploadedFiles = showUploadedFiles;
window.removeFile = removeFile;
window.validateAndNext = validateAndNext;
window.goToNextStep = goToNextStep;
window.goToPreviousStep = goToPreviousStep;
window.submitForm = submitForm;
